import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class SelectButton extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selected: props.selected
		};

		this.onClicked = this.onClicked.bind(this);
	}

	componentWillReceiveProps(newProps){
		// console.log(newProps);

		// if ( newProps.selected != this.props.selected) {
        // 	this.setState({ selected: this.props.selected });
        // }

		if ( newProps.customSelected) {
        	this.setState({ selected: false });
        }
		
	}

	componentDidUpdate(prevProps) {
        if (prevProps.selected !== this.props.selected) {
        	// if (this.props.id.includes("product") || 
        	// 	this.props.id.includes("allergic") || 
        	// 	this.props.id.includes("skinconcern")) {
	            this.setState({ selected: !prevProps.selected });
	        // } else {
	        // 	this.setState({ selected: prevProps.selected });
	        // }
        }

        // if (prevProps.customSelected !== this.props.customSelected && !this.props.customSelected) {
        // 	this.setState({ selected: false });
        // }
    }
	

	onClicked() {
		const selectable = this.props.selectable;
		const selected = this.state.selected;
		const isBudget = this.props.id.includes("budget");

		if (selectable && isBudget) {
			this.setState({ selected: true });
			if (this.props.onSelected && this.props.onDeselected) {
				const id = this.props.id;
				if (selected) {
					this.props.onDeselected(id);
				} else {
					this.props.onSelected(id);
				}
			}
		}

		if (selectable && !isBudget) {
			this.setState({ selected: !selected });
			if (this.props.onSelected && this.props.onDeselected) {
				const id = this.props.id;
				if (selected) {
					this.props.onDeselected(id);
				} else {
					this.props.onSelected(id);
				}
			}
		}
	}

	render() {
		const selectable = this.props.selectable;
		const selected = this.state.selected;
		const selectStyle = selected ? ' selected' : ' deselected';
		const selectableStyle = selectable ? ' selectable' : ' not-selectable';
		const athStyle = window.location.pathname.includes('/ath') ? ' ath-style' : '';
		return (
			<div className={ (athStyle === '' ? "skin-profile-select" : "hair-profile-select") + selectStyle + selectableStyle + athStyle } onClick={ this.onClicked }>
				<div className="select-button-title">{this.props.name}</div>
				{this.props.id === "product-13" ? <span className="subtitle">Cleanser, moisturizer, and SPF</span> : null}
		        {this.props.id === "product-14" ? <span className="subtitle">Cleanser, toner, moisturizer, exfoliator and SPF</span> : null}
			</div>
		);
	}
}

SelectButton.propTypes = {
	style: PropTypes.object,
	selectable: PropTypes.bool,
	selected: PropTypes.bool,
	id: PropTypes.string,
	onSelected: PropTypes.func,
	onDeselected: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/icon/SelectButton.js